import React from 'react';
import { Link } from 'react-router-dom';
import './ProgramPage.css';

const DataEngineering = () => {
  return (
    <div className="program-page">
      <section className="program-hero program-hero--red">
        <div className="container">
          <h1>Data Engineering Course for Building Scalable Data Systems</h1>
          <p className="hero-description">
            This data engineering course focuses on building, managing, and optimizing data pipelines and infrastructure used in modern data-driven organizations.
          </p>
        </div>
      </section>

      <section className="program-details section">
        <div className="container">
          <h2 className="section-title">Key Details</h2>
          <div className="details-grid">
            <div className="detail-card">
              <div className="detail-icon">🔄</div>
              <h3>ETL Concepts</h3>
              <p>Extract, Transform, and Load data efficiently</p>
            </div>
            <div className="detail-card">
              <div className="detail-icon">💾</div>
              <h3>Databases and SQL</h3>
              <p>Design and manage relational and NoSQL databases</p>
            </div>
            <div className="detail-card">
              <div className="detail-icon">🐍</div>
              <h3>Python for Data Engineering</h3>
              <p>Build data pipelines and automation scripts</p>
            </div>
            <div className="detail-card">
              <div className="detail-icon">☁️</div>
              <h3>Cloud Fundamentals</h3>
              <p>Work with cloud platforms and services</p>
            </div>
            <div className="detail-card">
              <div className="detail-icon">⚙️</div>
              <h3>Real-World Pipeline Projects</h3>
              <p>Build end-to-end data engineering solutions</p>
            </div>
          </div>
        </div>
      </section>

      <section className="program-cta section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Build Scalable Data Systems?</h2>
            <p>Join our upcoming batch and master data engineering</p>
            <Link to="/apply" className="btn btn-primary btn-large">
              Apply for Data Engineering Program
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DataEngineering;
